<div id="requester-access-form-cnt-root" class="p-b-m">
  <h5 class="p-16 m-0 bottomBorderStyle">Folder Permissions</h5>

  @if (packagefolder) {
    <div class="folderPermission-height p-16 p-b-m bottomBorderStyle" id="requester-access-form-cnt-details" [ngClass]="{ 'enableScroll': scrollable, 'disableScroll': !scrollable }">
      <div  class="p-b-15">
        <div class="form-value">Package Folder</div>
        <div class="form-value row-container horizontal-center-align h-2rem icon-color p-t-xs">
                <img class="icon-layout p-r-s" [src]="
                    'assets/images/bucket-icons/icon-folder.svg'
                " alt="folder img" />
            <div
              [attr.id]="buildFolderPermissionId('lbl-folder-name')"
              matTooltipClass="tooltip-style" matTooltipPosition="above"
              matTooltip="{{ packagefolder?.LeafName }}">
              {{ packagefolder?.LeafName }}
            </div>
          </div>
        </div>
        <form id="folderPermissionForm" [formGroup]="folderPermissionForm">
          <div class="p-b-l">
            <div class="form-value p-b-15">Add User</div>
            <div>
              <app-autocomplete
                id="requester-access-form-fld-requester"
                [textFormControl]="folderPermissionForm.controls.RequesterPuid"
                width=20.5 minType=3
                requiredErrorMessage="Name, Email Id or PUID is required"
                floatLabelOnBlur="Name or Email Id or PUID"
                floatLabelOnFocus="Name or Email Id or PUID"
                placeHolder="Enter Name or Email Id or PUID"
                [options]="requesterUserInfo"
                inputValidationErrorMessage="Please provide valid PUID"
                inputPattern='^[a-zA-Z0-9]{3,4}$'
                (valueChange)="autoCompleteId=1;getUserInfo($event)"
                (isOnFocus)="prePopulate=false;userFieldOnFocus=$event;setErrors()">
              </app-autocomplete>
              @if (folderPermissionForm.controls.RequesterPuid.errors?.SamePuid && !folderPermissionForm.controls.RequesterPuid.errors?.required) {
                <mat-error class="m-b--20 p-l-s"
                  >
                  User and GLP Manager cannot be same
                </mat-error>
              }
            </div>
          </div>
          <div class="p-b-l">
            <div class="form-value p-b-15">Add GLP Manager</div>
            <div>
              <app-autocomplete
                id="requester-access-form-fld-glp-manager"
                [textFormControl]="folderPermissionForm.controls.GLPManagerPuid"
                width=20.5 minType=3
                requiredErrorMessage="Name, Email Id or PUID is required"
                floatLabelOnBlur="Name or Email Id or PUID"
                floatLabelOnFocus="Name or Email Id or PUID"
                placeHolder="Enter Name or Email Id or PUID"
                [options]="glpManagerUserInfo"
                inputValidationErrorMessage="Please provide valid PUID"
                inputPattern='^[a-zA-Z0-9]{3,4}$'
                (valueChange)="autoCompleteId=2;getUserInfo($event)"
                (isOnFocus)="prePopulate=false;glpManagerFieldOnFocus=$event;setErrors()">
              </app-autocomplete>
              @if (folderPermissionForm.controls.GLPManagerPuid.errors?.SamePuid && !folderPermissionForm.controls.GLPManagerPuid.errors?.required) {
                <mat-error class="m-b--20 p-l-s"
                  >
                  User and GLP Manager cannot be same
                </mat-error>
              }
            </div>
          </div>
          <div class="p-b-15">
            <div class="form-value p-b-15"> Duration </div>
            <div class="durationField">
              <mat-form-field class="w-100" id="requester-access-form-ddl-duration"
                floatLabel="Duration" >
                <mat-label>
                  Duration</mat-label
                  >
                  <mat-select
                    [attr.id]="buildFolderPermissionId('ddl-duration-select')"
                    matInput
                    disableOptionCentering
                    placeholder="Duration"
                    formControlName="Duration"
                    panelClass="mat-select-panel durationpanel">
                    @for (duration of durationValues; track duration; let i = $index) {
                      <mat-option [value]="duration.id">
                        {{duration.displaytext}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (folderPermissionForm.controls.Duration.errors?.required) {
                    <mat-error
                      class="m-t-m"
                      >
                      Duration is required</mat-error
                      >
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="p-b-15 m-t-s">
              <div class="form-value p-b-15"> Justification </div>
              <div class="justificationField">
                <mat-form-field appearance="outline" class="Justification w-100" id="requester-access-form-fld-justification">
                  <textarea matInput formControlName="Justification" #justification placeholder="Please describe why this change was required *" maxlength="500" name="Justification" id="Justification" cols="30" rows="12"></textarea>
                  <mat-hint align="end" class="font-s m-t-m">{{justification.value.length}}/500</mat-hint>
                  @if (folderPermissionForm.controls.Justification.errors?.required) {
                    <mat-error
                      class="m-t-m"
                      >
                      Justification is required
                    </mat-error>
                  }
                  @if (folderPermissionForm.controls.Justification.errors?.minlength) {
                    <mat-error
                      class="m-t-m w-300"
                      >
                      Justification field must have more than 10 characters
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div>
              <button
                mat-raised-button
                color="primary"
                type="submit"
                class="button_content primary-hover w-p-100"
                id="requester-access-form-btn-submit"
                (click)="onSubmit()"
                >
                Submit
              </button>
            </div>
          </form>
        </div>
      }

      @if (packagefolder !== null) {
        <div class="p-t-m">
          <h7 class="p-16 form-value font-xl p-t-m">Current Permission Holders</h7>
          @if (activePermissionHolders.length>0) {
            <div class="enableScroll activePermissionsHeight p-t-m bottomBorderStyle p-b-m">
              @for (activePermissionHolder of activePermissionHolders; track activePermissionHolder) {
                <div class="p-16" (mouseenter)="activePermissionHolder.showRevokeAccess=true" (mouseleave)="activePermissionHolder.showRevokeAccess=false">
                  <div class="form-value">
                    <span
                      id="requester-access-form-btn-holder-{{ activePermissionHolder.activePermissionHoldersResponse.RequesterPUID }}"
                      (click)="showInformation($event, activePermissionHolder.activePermissionHoldersResponse)"
                      [class.text-puid]="activePermissionHolder?.activePermissionHoldersResponse && activePermissionHolder.activePermissionHoldersResponse?.RequesterFullName && activePermissionHolder.activePermissionHoldersResponse?.RequesterEmailId"
                      [class.pointCursor]="activePermissionHolder?.activePermissionHoldersResponse?.RequesterFullName && activePermissionHolder.activePermissionHoldersResponse?.RequesterEmailId"
                      >
                      {{activePermissionHolder.activePermissionHoldersResponse.RequesterPUID.toUpperCase()}}
                    </span>
                  </div>
                  <div class="form-value row-container horizontal-center-align h-20 pointCursor" id="requester-access-form-btn-prepopulate-{{ activePermissionHolder.activePermissionHoldersResponse.RequesterPUID }}" (click)="PrePopulate(activePermissionHolder.activePermissionHoldersResponse); scrollToTop()">
                    <div class="font-s">
                      {{ activePermissionHolder.activePermissionHoldersResponse.StartDateTime + "Z" | date : "dd/MM/yyyy | HH:mm " }} &nbsp; <span class="font-xxl">-</span> &nbsp; {{ activePermissionHolder.activePermissionHoldersResponse.EndDateTime + "Z" | date : "dd/MM/yyyy | HH:mm " }}
                    </div>
                    <span class="pl-p-6 p-b-15">
                      @if (activePermissionHolder.showRevokeAccess) {
                        <button mat-icon-button id="requester-access-form-btn-revoke-{{ activePermissionHolder.activePermissionHoldersResponse.RequesterPUID }}" (click)="confirmRevokeAccess(activePermissionHolder.activePermissionHoldersResponse)" color="accent">
                          <i class="icon-ic-remove-doc pointCursor" matTooltipClass="tooltip-style" matTooltipPosition="above" matTooltip="Revoke Access">
                          </i>
                        </button>
                      }
                    </span>
                  </div>
                </div>
              }
            </div>
          }
          @if (activePermissionHolders.length===0) {
            <p class="form-label pl-p-20 pr-p-15 font-l p-t-m p-b-m bottomBorderStyle">No current active permission to consult this package.</p>
          }
        </div>
      }
    </div>
